import { useEffect, useState } from 'react';
import { meetingSessionService } from '../services/meetingSessionService';
import { useUser } from './useUserData';

const SKELETON_DELAY_MS = 200;

interface AuthTransitionState {
  isTransitioning: boolean;
  showSkeleton: boolean;
}

function useAuthTransition(): AuthTransitionState {
  const { isLoading: loginInProgress, idToken, isAuthenticated } = useUser();

  const isTransitioning =
    (Boolean(loginInProgress) || (Boolean(idToken) && !isAuthenticated)) &&
    !meetingSessionService.isMeetingActive();
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    if (isTransitioning) {
      const timer = setTimeout(() => setShowSkeleton(true), SKELETON_DELAY_MS);
      return () => clearTimeout(timer);
    }
    setShowSkeleton(false);
  }, [isTransitioning]);

  return { isTransitioning, showSkeleton };
}

export default useAuthTransition;
